module.exports = "<app-banner></app-banner>\r\n<app-services></app-services>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = home.module